export default __webpack_public_path__ + "static/media/memory-matrix-guide.3ae928b7.mp4";